import * as React from "react"

import { cn } from "../../lib/utils"

// 26BET design-kit EmptyState: icon + title + description + optional CTA —
// see checklist item "EmptyState: standard icon + title + description +
// optional CTA pattern (My Bets, Betslip, Live, empty fixtures)".
function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: React.ComponentType<{ className?: string }>
  title: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
  className?: string
}) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        "flex flex-col items-center justify-center gap-[10px] px-6 py-16 text-center",
        className
      )}
    >
      {Icon ? (
        <div className="mb-1 flex size-12 items-center justify-center rounded-full !border !border-[var(--border-subtle)] bg-[var(--surface-2)] text-[var(--text-muted)]">
          <Icon className="size-5" />
        </div>
      ) : null}
      <div className="text-base font-semibold text-[var(--text-primary)]">{title}</div>
      {description ? (
        <p className="max-w-[38ch] text-[13px] leading-[1.45] text-[var(--text-muted)]">{description}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  )
}

export { EmptyState }
